import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Duration in the Test Manager's shape (`0s`, `45s`, `2m 30s`, `1h 4m`) —
 * ported from KTM utils/helpers.ts formatDuration, adapted from seconds to
 * milliseconds (evidence packs author duration_ms).
 */
export function formatDurationMs(ms) {
  if (ms === null || ms === undefined || Number.isNaN(ms) || ms < 0) {
    return '—';
  }
  var totalSeconds = Math.round(ms / 1000);
  if (totalSeconds < 60) return "".concat(totalSeconds, "s");
  var totalMinutes = Math.floor(totalSeconds / 60);
  var seconds = totalSeconds % 60;
  if (totalMinutes < 60) {
    return seconds > 0 ? "".concat(totalMinutes, "m ").concat(seconds, "s") : "".concat(totalMinutes, "m");
  }
  var hours = Math.floor(totalMinutes / 60);
  var minutes = totalMinutes % 60;
  return minutes > 0 ? "".concat(hours, "h ").concat(minutes, "m") : "".concat(hours, "h");
}

/**
 * kaneai's ExecutionTimeBadge format (resolveExecutionDuration): sub-second
 * durations in ms, else one-decimal seconds — "785ms", "5.7s". Distinct from
 * formatDurationMs (the header "2m 45s" shape).
 */
export function formatChipDuration(ms) {
  if (ms === null || ms === undefined || Number.isNaN(ms) || ms < 0) return null;
  return ms < 1000 ? "".concat(Math.round(ms), "ms") : "".concat((ms / 1000).toFixed(1), "s");
}

/**
 * Middle truncation for identifiers ("01KX064ZSQBRG556D7NVX8WC5P" →
 * "01KX064Z…VX8WC5P") — the head and tail are what humans compare. Same
 * spirit as lt-components' tag truncation. Pair with a title tooltip.
 */
export function truncateMiddle(text) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  if (text.length <= max) return text;
  var keep = max - 1;
  var head = Math.ceil(keep / 2);
  var tail = Math.floor(keep / 2);
  return "".concat(text.slice(0, head), "\u2026").concat(text.slice(text.length - tail));
}

/** "1.2 KB", "3.4 MB" — for the stream meter. */
export function formatBytes(n) {
  if (n < 1024) return "".concat(n, " B");
  if (n < 1024 * 1024) return "".concat((n / 1024).toFixed(1), " KB");
  return "".concat((n / (1024 * 1024)).toFixed(1), " MB");
}
var RELATIVE_UNITS = [['year', 1000 * 60 * 60 * 24 * 365], ['month', 1000 * 60 * 60 * 24 * 30], ['week', 1000 * 60 * 60 * 24 * 7], ['day', 1000 * 60 * 60 * 24], ['hour', 1000 * 60 * 60], ['minute', 1000 * 60]];

/** "2 days ago" / "just now" from an ISO timestamp; null when unparsable. */
export function relativeTime(iso) {
  if (!iso) return null;
  var t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  var delta = t - Date.now();
  var rtf = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto'
  });
  var _iterator = _createForOfIteratorHelper(RELATIVE_UNITS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        unit = _step$value[0],
        msPerUnit = _step$value[1];
      if (Math.abs(delta) >= msPerUnit) {
        return rtf.format(Math.round(delta / msPerUnit), unit);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return 'just now';
}

/** Free-form environment.os string → icon key. */
export function toOSKey(os) {
  var s = (os !== null && os !== void 0 ? os : '').toLowerCase();
  if (!s) return 'unknown';
  if (s.includes('win')) return 'windows';
  if (s.includes('ios') || s.includes('iphone') || s.includes('ipad')) {
    return 'ios';
  }
  if (s.includes('mac') || s.includes('os x') || s.includes('darwin')) {
    return 'macos';
  }
  if (s.includes('android')) return 'android';
  if (s.includes('linux') || s.includes('ubuntu')) return 'linux';
  return 'unknown';
}

/** Free-form environment.browser string → icon key. */
export function toBrowserKey(browser) {
  var s = (browser !== null && browser !== void 0 ? browser : '').toLowerCase();
  if (!s) return 'unknown';
  if (s.includes('edge')) return 'edge';
  if (s.includes('opera')) return 'opera';
  if (s.includes('chrom')) return 'chrome'; // chrome, chromium
  if (s.includes('firefox') || s.includes('gecko')) return 'firefox';
  if (s.includes('safari') || s.includes('webkit')) return 'safari';
  return 'unknown';
}
var OS_DISPLAY = {
  windows: 'Windows',
  macos: 'macOS',
  ios: 'iOS',
  android: 'Android',
  linux: 'Linux',
  unknown: 'Operating system'
};
var BROWSER_DISPLAY = {
  chrome: 'Chrome',
  firefox: 'Firefox',
  safari: 'Safari',
  edge: 'Edge',
  opera: 'Opera',
  unknown: 'Browser'
};

/** Human names for the icon keys — screen-reader text alternatives for
 * information the aria-hidden icons convey visually. */
export var osDisplayName = function osDisplayName(os) {
  return OS_DISPLAY[os];
};
export var browserDisplayName = function browserDisplayName(b) {
  return BROWSER_DISPLAY[b];
};

/** The detail header's OS text: "Windows 10.0.22000", but just "Linux" —
 * a kernel build ("5.15.0-1088-azure") means nothing to users. */
export function osHeaderLabel(os, osVersion) {
  if (!os || os.trim() === '') return null;
  if (toOSKey(os) === 'linux') return 'Linux';
  return osVersion ? "".concat(os, " ").concat(osVersion) : os;
}
var escapeRegExp = function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/**
 * The OS label next to the OS icon — KTM's getOSVersionDisplay strips the OS
 * name out of the version ("macOS Monterey" → "Monterey"). Falls back to the
 * plain os string when there is no version.
 */
export function osLabel(os, osVersion) {
  // Linux versions are kernel builds ("5.15.0-1088-azure") — noise to users.
  if (toOSKey(os) === 'linux') return 'Linux';
  if (osVersion && osVersion.trim() !== '') {
    if (os) {
      var stripped = osVersion.replace(new RegExp(escapeRegExp(os), 'gi'), '').trim();
      // "macOS Monterey" → "Monterey"; when the version IS the os name,
      // fall back to the os so the label is never empty.
      return stripped !== '' ? stripped : os;
    }
    return osVersion;
  }
  return os && os.trim() !== '' ? os : null;
}